export default __webpack_public_path__ + "static/media/logo.65799098.png";